export default "__VITE_ASSET__D2Xsv3Hk__"